// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';

class PriceRangeFields extends Component {
  render() {
    const {
      labelTitle,
      preLabelText,
      name,
      placeholderText,
      handleChange,
      handleInputChange,
      value
    } = this.props;
    
    return ( 
      <div className="filter-v2__input-text">
        <label className="filter-v2__input-text-label">
          { labelTitle }
        </label>
        <div className="filter-v2__input-text-field-wrapper">
          { preLabelText && (
            <span className="filter-v2__input-text-pre-label">{ preLabelText }</span>
          )}
          <input
            className="filter-v2__input-text-field"
            name={name}
            onInput={handleInputChange}
            placeholder={placeholderText}
            onChange={handleChange}
            value={value}
          />
        </div>
      </div>
    );
  }
}

PriceRangeFields.defaultProps = {
  handleChange: () => {},
  handleInputChange: () => {},
  value: null,
};

PriceRangeFields.propTypes = {
  handleChange: PropTypes.func,
  handleInputChange: PropTypes.func,
  value: PropTypes.any,
};

export default PriceRangeFields;
